/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import {
    IKRV_ATPLeadTimePropertiesDateRequestEntity,
    IKRV_GetMultipleATPLeadTimeResponseDate
} from './customProxy/ATP-update/DataServiceEntities.g';
import { kRV_GetMultipleATPLeadTimeDateAsync } from './customProxy/ATP-update/DataActionExtension.g';

/**
 * GetAtpdataPlp Input Action
 */
export class GetAtpdataPlpInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    public products: any[];
    public atpData: any[];
    constructor(products: any[], atpData: any[]) {
        this.products = products;
        this.atpData = atpData;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => (this.products ? this.products.map(obj => obj?.RecordId).join('-') : 'atpDataPlp');
    public getCacheObjectType = () => 'atpDataPlp';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetAtpdataPlpData {
    products: any[];
    atpData: any[];
    ctx: Msdyn365.IActionContext;
}

/**
 * TODO: Use this function to call your action and process the results as needed
 */
export async function atpDataPlpaction(
    input: GetAtpdataPlpInput,
    actionContext: Msdyn365.IActionContext
): Promise<IKRV_GetMultipleATPLeadTimeResponseDate | null> {
    const { products, atpData } = input;
    //let productsRecIdsConcat = '';
    const KRVATPLeadTimeDate: IKRV_ATPLeadTimePropertiesDateRequestEntity[] = [];
    //Create date according to API
    const objectDate = new Date();
    const day = objectDate.getDate();
    const month = objectDate.getMonth();
    const year = objectDate.getFullYear();
    const requestedDate = `${day}/${month + 1}/${year}`;

    if (products.length > 0 && atpData.length === 0) {
        products?.map((e: any) => {
            KRVATPLeadTimeDate.push({
                itemID: e.ItemId,
                requestedDate: requestedDate
            });
        });
    } else {
        const atpItemIds = new Set(atpData?.map((item: { ItemId: any }) => item.ItemId));
        products.forEach(product => {
            if (atpItemIds.has(product.ItemId)) {
                return;
            } else {
                KRVATPLeadTimeDate.push({
                    itemID: product.ItemId,
                    requestedDate: requestedDate
                });
            }
        });
    }
    const ctx = { callerContext: actionContext };
    try {
        const response = await kRV_GetMultipleATPLeadTimeDateAsync(ctx, KRVATPLeadTimeDate);
        return response;
    } catch (err) {
        console.error(err, 'ERR');
    }
    return null;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetAtpdataPlpData>>(<unknown>atpDataPlpaction),
    // TODO: Give your data action a unique id
    id: 'GetAtpdataPlp'
    //input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
